import "regenerator-runtime/runtime.js";
import { $, getJson } from 'donot';
import Vue from 'vue';
import { createView } from './view.js';

const $html = $("html");

function addSupportClasses() {
    const type = 'ontouchend' in window ? 'has-touch' : 'has-mouse';
    $html.classList.add(type);
    $html.classList.remove('no-js');
    $html.classList.add('has-js');
}

async function main() {
    addSupportClasses();

    // FIXME
    $(".project").classList.remove('project');

    const data = await getJson('data/data.json');
    createView(data);
}

main();